import Service from 'ember-simple-auth/services/session';

export interface AuthenticatedUser {
  email?: string;
  email_verified?: boolean;
  nickname?: string;
  name?: string;
  picture?: string;
  primaryIdentity?: string;
  isSSO?: boolean;
  sub?: string;
  updated_at?: string;
}

export type SessionServiceData = {
  authenticated: {
    id: string;
    user?: AuthenticatedUser;
    accessToken?: string;
  };
};

// actual service is located in the `hcp/app/services/session` package
export default class SessionService extends Service<SessionServiceData> {}
